import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('loading.routes.index'),
        name: 'loading',
        component: () =>
            import(/* webpackChunkName: "loading" */ '@/views/Loading.vue'),
        props: true,
        meta: {
            title: 'loading',
        },
    },
]
